import React from "react";
import { Input, Select, Button } from "antd";
import { RiCheckboxMultipleLine } from "react-icons/ri";

const StationFilters = ({
  nameFilter,
  onNameFilterChange,
  placementFilter,
  onPlacementFilterChange,
  categoryFilter,
  onCategoryFilterChange,
  getUniqueCategories,
  batchMode,
  onBatchModeToggle,
}) => {
  return (
    <div style={{ marginBottom: 12 }}>
      <Input
        placeholder="搜尋基站名稱"
        value={nameFilter}
        onChange={(e) => onNameFilterChange(e.target.value)}
        allowClear
        style={{ marginBottom: 8 }}
      />
      <div
        style={{
          display: "flex",
          gap: 8,
          marginBottom: 8,
        }}
      >
        <Select
          placeholder="放置狀態"
          value={placementFilter}
          onChange={onPlacementFilterChange}
          style={{ flex: 1 }}
          options={[
            { label: "全部", value: "all" },
            { label: "已放置", value: "placed" },
            { label: "未放置", value: "unplaced" },
          ]}
        />
        <Select
          placeholder="基站類型"
          value={categoryFilter}
          onChange={onCategoryFilterChange}
          style={{ flex: 1 }}
          options={[
            { label: "全部", value: "all" },
            ...getUniqueCategories().map((cat) => ({
              label: cat,
              value: cat,
            })),
          ]}
        />
      </div>
      <Button
        type={batchMode ? "primary" : "default"}
        icon={<RiCheckboxMultipleLine />}
        onClick={onBatchModeToggle}
        style={{ width: "100%" }}
      >
        {batchMode ? "退出批次模式" : "批次編輯模式"}
      </Button>
    </div>
  );
};

export default StationFilters;

